import React from "react";

const DataModal = ({ isOpen, onClose, data }) => {
  if (!isOpen || !data || !data.length) return null;

  const tableData = Array.isArray(data[0]) ? data : [data];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div
              className="bg-white dark:bg-gray-800 text-black dark:text-white max-h-[80vh] w-full max-w-6xl rounded-lg shadow-lg p-6 overflow-auto transition-colors"
              style={{ WebkitOverflowScrolling: "touch", overflowY: "auto" }}
          >
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Tables</h2>
          <button
            onClick={onClose}
            className="text-gray-600 dark:text-gray-300 hover:text-red-600 dark:hover:text-red-400 text-xl font-bold"
          >
            &times;
          </button>
        </div>

        {tableData.map((table, tableIndex) => {
          if (!table || !table.length) return null;
          const headers = Object.keys(table[0]);

          return (
            <div key={tableIndex} className="mb-8">
              {tableData.length > 1 && (
                <h3 className="text-lg font-semibold mb-2">
                  Table {tableIndex + 1}
                </h3>
              )}
              <div className="overflow-auto">
                <table className="min-w-full border border-gray-300 dark:border-gray-600 text-sm mb-4">
                  <thead className="bg-gray-200 dark:bg-gray-700">
                    <tr>
                      {headers.map((header, index) => (
                        <th
                          key={index}
                          className="border border-gray-300 dark:border-gray-600 p-2 text-left"
                        >
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {table.map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        {headers.map((header, colIndex) => (
                          <td
                            key={colIndex}
                            className="border border-gray-300 dark:border-gray-600 p-2"
                          >
                            <span
                              dangerouslySetInnerHTML={{
                                __html: row[header] || "",
                              }}
                            />
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          );
        })}

        <div className="mt-4 flex justify-end">
          <button
            onClick={onClose}
            className="bg-gray-600 dark:bg-gray-700 text-white px-4 py-2 rounded hover:bg-gray-700 dark:hover:bg-gray-600 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default DataModal;
